var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canShowModifiedDate)?_c('AxShortcutModified',{attrs:{"project-id":_vm.item.lastUpdatedShortcut,"project-modified":_vm.item.updated,"project-state":_vm.item.shortcutState}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }